import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class ComplianceActivity extends PureComponent {
    static propTypes = {
        date: PropTypes.string,
        img: PropTypes.string,
        name: PropTypes.string
    };

    render () {
        const { commentRow, linkMessage } = styles
        return (
            <div className='profile__activity' style={{
                border: 2,
                borderBottom: 1,
                borderColor: '#F00',
                //paddingBottom: 18
            }}>
                <div id='profile__activity__comment' style={commentRow}>
                    {this.props.children}
                </div>
                <div id='profile__activity__details' style={commentRow}>
                    <p className='profile__activity-name'><span
                        className='profile__activity-date'>{this.props.date}.  </span> {this.props.name}  </p>
                </div>
                {this.props.type === 'url-container' ?
                    <p style={linkMessage}>Please ensure that your link is secure.</p> :
                    null}
            </div >
        )
    }
}

const styles = {
    commentRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    linkMessage: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        fontSize: 12,
        paddingBottom: 10,
        margin: 0
    }
}



// WEBPACK FOOTER //
// ./src/components/ComplianceActivity.js